import React from 'react';

export default class SearchBar extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <form action="/search" className="search">
        <div className="search__inner">
          <input name="utf8" className="form-control" type="hidden" value="√" />
          <input
            className="search__text"
            placeholder="Search for doctors, hospitals, articles, videos, and more"
            type="text"
            onFocus={() => this.props.showDropdown()}
            onBlur={() => this.props.hideDropdown()}
            value={this.props.term}
            onChange={(event) => { this.props.onSearchTermChange(event.target.value) }}
            autoComplete="off"
            name="search[q]"
            id="search_q"
          />
          <i className="zmdi zmdi-search search__helper" data-ma-action="search-close"></i>
        </div>
      </form>
    );
  }
}
